<wk-icon-client-code-sprite-pds3 />
<icon-pds3 name="wk-icon-client-code" />
<span class="wk-cm__header__icon-text">
    @if (cardModalService.currentDashboard()?.ApplicationType === 20) {
        <a role="link" (click)="handleOpenContact()" (keydown.enter)="handleOpenContact()">
            {{ cardModalService.currentCard()?.contactInformation?.clientCode | truncate: 15 }}
        </a>

        @if (cardModalService.currentCard()?.contactInformation?.clientCode?.toString()?.length > 15) {
            <tooltip-pds3
                position="bottom"
                mode="description"
                [openDelay]="600"
                [closeDelay]="50"
                targetSelector=".wk-cm__header__icon-clientcode .wk-cm__header__icon-text"
            >
                {{ cardModalService.currentCard()?.contactInformation?.clientCode }}
            </tooltip-pds3>
        }
    } @else {
        @if (isContactClickable) {
            <a role="link" (click)="handleOpenContact()" (keydown.enter)="handleOpenContact()">
                {{ cardModalService.currentCard()?.clientCodes?.[currentDashboard?.ClientCode] | truncate: 15 }}
            </a>
        } @else {
            {{ cardModalService.currentCard()?.clientCodes?.[currentDashboard?.ClientCode] | truncate: 15 }}
        }

        @if (cardModalService.currentCard()?.clientCodes?.[currentDashboard?.ClientCode]?.length > 15) {
            <tooltip-pds3
                position="bottom"
                mode="description"
                [openDelay]="600"
                [closeDelay]="50"
                targetSelector=".wk-cm__header__icon-clientcode .wk-cm__header__icon-text"
            >
                {{ cardModalService.currentCard()?.clientCodes?.[currentDashboard?.ClientCode] }}
            </tooltip-pds3>
        }
    }
</span>

<tooltip-pds3 position="bottom" mode="indicator" [openDelay]="600" [closeDelay]="50" targetSelector=".wk-cm__header__icon-clientcode icon-pds3">
    {{ "CardModal.ClientCode" | translate }}
</tooltip-pds3>
